export default "__VITE_ASSET__f5d4fe0a__"